import React from 'react';

import { Tooltip, TooltipBox, TooltipChild } from './style';

const useTooltip = ({ children, text, textColor, boxColor }) => {
  return (
    <Tooltip boxColor={boxColor} textColor={textColor}>
      <TooltipChild>{children}</TooltipChild>
      <TooltipBox>
        <p>{text}</p>
      </TooltipBox>
    </Tooltip>
  );
};

export default useTooltip;



// WEBPACK FOOTER //
// ./src/components/Tooltip/index.js